const qnVersionMatch = /Qianniu\/(.+?)(N|QNM) /.exec(window.navigator.userAgent);

export const qnVersion = qnVersionMatch?.[1];
const qnPlatform = qnVersionMatch?.[2];

export const isQnMac = qnPlatform === "QNM";
export const isQnWindows = qnPlatform === "N";

/**前端项目url */
export const FD_BASE_URL = import.meta.env.VITE_FD_BASE_URL;

/**用户协议链接 */
export const USER_AGREEMENT_URL = `https://cdn.fahuoyi.com/assets/user-agreement.html`;

/**c端前端项目url */
export const CLIENT_FD_BASE_URL = "https://c.fahuoyi.com";

// 由于平台安全规范要求，淘宝、京东、拼多多、贝贝要求将数据存储在平台云服务，需要后端会有多个服务器
/**淘宝node */
export const JUSHITA_OMS_BASE_URL = import.meta.env.VITE_JUSHITA_OMS_BASE_URL;

/**拼多多node */
export const PDD_OMS_BASE_URL = import.meta.env.VITE_PDD_OMS_BASE_URL;

/** 抖店node */
export const DOUDIAN_OMS_BASE_URL = import.meta.env.VITE_DOUDIAN_OMS_BASE_URL;

/**京东node */
export const JD_OMS_BASE_URL = import.meta.env.VITE_JD_OMS_BASE_URL;

/**其他node */
export const ALIYUN_OMS_BASE_URL = import.meta.env.VITE_ALIYUN_OMS_BASE_URL;

export const LH_API_BASE_URL = import.meta.env.VITE_LH_API_BASE_URL;

export const LH_CUSTOMER_API_BASE_URL = import.meta.env.VITE_LH_CUSTOMER_API_BASE_URL;

export const LH_H5_BASE_URL = import.meta.env.VITE_LH_H5_BASEURL;

/**分销易邀请图片 链接地址 */
export const inviteUrl = "https://img.alicdn.com/imgextra/i4/54458674/O1CN01p6zeaW2Dwk9UrPfPM_!!54458674.jpg";

/**
 * 响应白名单，失败响应空数据。
 */
export const stillSuccessUrlList = [
    "/company/customization_shop_authorized_info",
    "/shop/get",
    "/order/overview",
    "/shop/batchGet",
    "/customization/shop/customization_shop_authorized_info",
    "/frontend_logger/info",
];

/**
 *  店铺授权失效导致接口501，不弹出授权弹窗，自行处理,返回Promise.resolve
 */
export const authInvalidNotShowModalList = ["/order/search"];

/**
 * 打单店铺授权失效，返回Promise.reject
 */
export const authInvalidRejectList = [
    "/ewaybill/generate",
    "/scan_printing/ewaybill/generate",
    "/purchasing_label/ewaybill/generate",
];

/**
 * 这些地址不显示登录授权过期提示框
 */
export const hiddenLoginExpiryModalPathname = ["/login", "/partnership/login", "/logout"];

/**
 * 错误提示白名单地址，发生错误由相对应的业务自行处理错误，不由请求拦截器触发错误弹框
 */
export const errorModalWitheUrlList = [
    "/order/ship",
    "/scan_printing/order/ship",
    "/purchasing_label/order/ship",
    "/order/reship",
    "/drop_shipping_order/pay",
    "/drop_shipping_order/pending_payment/total_amount",
    "/ewaybill/generate",
    "/scan_printing/ewaybill/generate",
    "/purchasing_label/ewaybill/generate",
    "/shop/valid_association_code",
    "/tenant_db_update/execute_update_sql",
    "/drop_shipping_partnership/get_retailer_shop_by_partnership_code",
    "/order/list_decrypted_consignee",
    "/order/list_decrypted_consignee_for_print",
    "/shop/pdd_associate_invitation",
    "/purchasing_label/get_print_data/",
    "/scan_printing/get_by_original_id",
    "/scan_printing/get_by_waybill_no",
];

/**
 * 代理商登录链接
 */
export const retailerLoginUrl = `${FD_BASE_URL}/login`;

/**
 * 供货商登录链接
 */
export const supplierLoginUrl = `${FD_BASE_URL}/partnership/login`;

/**
 * 供货商注册链接
 */
export const supplierRegisterUrl = `${FD_BASE_URL}/partnership/register`;

/**用于跳转打开千牛的来火定制admin后台 */
export const openQNCustomizationUrl = "https://fuwu.taobao.com/ser/miniAppUse.htm?articleCode=FW_GOODS-1001101601";

/**来火定制视频演示 */
export const lhOrderTutorialVideoUrl = "https://cloud.video.taobao.com/play/u/54458674/p/1/e/6/t/1/346010182537.mp4";

export const WeChatUrl = "https://work.weixin.qq.com/kfid/kfc0645158af2fcf8e2";

/**
 * 菜鸟打印组件链接
 */
export const CNPrinterDownloadURL = "https://page.cainiao.com/waybill/cloud_printing/home.html";

export const CNPrinterForMacDownloadURL = "https://page.cainiao.com/waybill/cloud_printing/home.html";

export const PDDPrinterDownloadURL =
    "https://meta.pinduoduo.com/api/one/app/v1/lateststable?appId=com.xunmeng.pddsecprinter&platform=windows&subType=main";

export const JDPrinterDownloadUrl = "https://prod-oms-app-cprt.jdwl.com/OpenCloudPrint/setup.exe";

export const DyPrintDownloadUrl = "https://logistics.douyinec.com/davinci/CloudPrintClient";

export const DyPrintForMacDownloadUrl = "https://logistics.douyinec.com/davinci/CloudPrintClientForMac";

export const KSPrintDownloadUrl = "https://cloudprint.kwaixiaodian.com/rest/pc/scm/ebill/print/installer/download";

export const SFPrintDownloadUrl = "https://scp-tcdn.sf-express.com/scp/soft/SCPPrint_Win32NT_6.570CN.exe";

export const ChannelShopPrintDownloadUrl =
    "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/e4TWKgMu17AalV2l";

export const ChannelShopPrintForMacDownloadUrl =
    "https://mmec-shop-1258344707.cos.ap-shanghai.myqcloud.com/shop/print/download/ChannelsShopPrintClient.dmg";

export const XiaoHongShuPrintDownloadUrl =
    "https://xhswaybill-printer-1251524319.cos.ap-shanghai.myqcloud.com/XHPrintTool/prod/win/xiaohongshu-win.exe";

export const XiaoHongShuPrintForMacDownloadUrl =
    "https://xhswaybill-printer-1251524319.cos.ap-shanghai.myqcloud.com/XHPrintTool/prod/win/xiaohongshu-mac.dmg";

export const NextXiaoHongShuPrintDownloadUrl =
    "https://xhswaybill-printer-1251524319.cos.ap-shanghai.myqcloud.com/XHSPrintClient/prod/windows/xhs-electron-printer_x64-setup.exe";

export const NextXiaoHongShuPrintForMacDownloadUrl =
    "https://xhswaybill-printer-1251524319.cos.ap-shanghai.myqcloud.com/XHSPrintClient/prod/macos/xhs-electron-printer_universal.dmg";

export const AiKuCunPrintDownloadUrl = "https://mx-lews-web.aikucun.com/merchant/xiazai#/";

/**
 * 抖店云app key
 */
export const DOUDIAN_SE_APP_KEY = "6838416245163820552";

/**
 * 淘宝来火定制订购链接
 */
export const lhCustomizationSubscribeUrl = "https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1001101601";

export const ShareEwaybillUrl = "https://share.fahuoyi.com/";

export const registerBackgroundUrl =
    "https://img.alicdn.com/imgextra/i1/54458674/O1CN01AEYi3x2DwkJ2ClFRc_!!54458674.jpg";
